(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-buy-behavior"] && !Shopify.designMode) return;
  try {
    (function(){
if(window.pfBuyBound)return;window.pfBuyBound=true;
document.addEventListener('click',function(event){
var link=event.target.closest('a[data-pf-retailer]');
if(link){
var section=link.closest('[data-pf-placement]');
var payload={retailer:link.dataset.pfRetailer,placement:section?section.dataset.pfPlacement:'navigation',isbn:'9798992583137',destination:link.href};
document.dispatchEvent(new CustomEvent('pf:retailer-click',{detail:payload}));
var consent=window.Shopify&&Shopify.customerPrivacy;
if(consent&&typeof consent.analyticsProcessingAllowed==='function'&&consent.analyticsProcessingAllowed()){
if(typeof window.gtag==='function'){window.gtag('event','retailer_click',payload);}
else if(Array.isArray(window.dataLayer)){window.dataLayer.push(Object.assign({event:'retailer_click'},payload));}
if(window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){window.Shopify.analytics.publish('pf_retailer_click',payload);}
}
if(consent&&typeof consent.marketingAllowed==='function'&&consent.marketingAllowed()&&typeof window.fbq==='function'){window.fbq('trackCustom','RetailerClick',payload);}
}
var copy=event.target.closest('[data-pf-copy-isbn]');
if(copy&&navigator.clipboard){
navigator.clipboard.writeText('9798992583137').then(function(){copy.nextElementSibling.textContent=copy.dataset.success;}).catch(function(){copy.nextElementSibling.textContent=copy.dataset.failure;});
}
});
})();
  } catch(e) { console.error(e); }
})();

})();
